import { ReactNode } from "react";

import { Cores, Icone } from "@componentes-mu/componentes-mu";

import styles from './styles.module.scss'
import { SortDirection } from "../types";


type TableHeaderCellProps = {
    children: ReactNode;
    style?: React.CSSProperties;
    sortable?: boolean;
    onSort?: () => void;
    currentSortDirection?: SortDirection;
}

export const TableHeaderCell = ({ children, style, sortable, onSort, currentSortDirection }: TableHeaderCellProps) => {
    return (
        <th className={styles.headerCell} style={style} onClick={sortable ? onSort : undefined}>
            <div className={styles.columnCell}>
                <div className={styles.columnTitle}>
                    {children}
                </div>
                {sortable && (
                    <span className={styles.sortIcon}>
                        <Icone
                            nome="filter_list"
                            altura="18px"
                            largura="18px"
                            className={currentSortDirection === SortDirection.DESC ? styles.rotatedIcon : undefined}
                            cor={(currentSortDirection === SortDirection.DESC || currentSortDirection === SortDirection.ASC) ?
                                Cores.CoresIdentidadeMU.azulMu : Cores.CoresIdentidadeMU.cinzaMu
                            }
                        />
                    </span>
                )}
            </div>
        </th>
    )
}